import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  user: null,
  formResponsesData: [],
  countries: [
    {value: 'DE'}, {value: 'ES'}, {value: 'FR'},
    {value: 'IT'}, {value: 'MX'}
  ],
  departments: [
    {value: 'Software'}, {value: 'Change Mgmt'},
    {value: 'Architecture'}, {value: 'MD'},
    {value: 'HR'}, {value: 'Alibey'},
    {value: 'Backoffice'}
  ],
  selectedCountry: null,
  selectedDepartment: null,
  allUsersData: [],
  isLoading: false
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js